export default __webpack_public_path__ + "images/LG.82e74dc.png";